import { useEffect } from 'react';
import { seo } from '../data/seo';
import { event } from '../data/event';

export function useDocumentMeta() {
  useEffect(() => {
    const url = window.location.origin + window.location.pathname;

    document.documentElement.lang = seo.lang;
    document.title = seo.title;

    setMeta('name', 'description', seo.description);
    setMeta('name', 'keywords', seo.keywords);
    setMeta('name', 'robots', 'index, follow, max-image-preview:large');
    setMeta('name', 'theme-color', seo.themeColor);
    setMeta('name', 'viewport', 'width=device-width, initial-scale=1, viewport-fit=cover');

    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:locale', seo.locale);
    setMeta('property', 'og:site_name', seo.siteName);
    setMeta('property', 'og:title', seo.title);
    setMeta('property', 'og:description', seo.description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', seo.image);
    setMeta('property', 'og:image:alt', seo.imageAlt);

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', seo.title);
    setMeta('name', 'twitter:description', seo.description);
    setMeta('name', 'twitter:image', seo.image);
    setMeta('name', 'twitter:image:alt', seo.imageAlt);

    setLink('canonical', url);

    setJsonLd({
      '@context': 'https://schema.org',
      '@type': 'Event',
      name: 'Deuxième webinaire – La Rentrée Touristique',
      description: seo.description,
      startDate: seo.eventStart,
      eventStatus: 'https://schema.org/EventScheduled',
      eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
      inLanguage: seo.lang,
      image: [seo.image],
      location: { '@type': 'VirtualLocation', url: event.liveUrl || url },
      organizer: {
        '@type': 'Organization',
        name: seo.organizerName,
        logo: event.organizerLogo,
      },
      offers: {
        '@type': 'Offer',
        url: event.formUrl,
        price: 0,
        priceCurrency: 'MAD',
        availability: 'https://schema.org/InStock',
      },
    });
  }, []);
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}

function setJsonLd(data: Record<string, unknown>) {
  const id = 'event-jsonld';
  let el = document.getElementById(id) as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement('script');
    el.id = id;
    el.type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}
